import { Banner, Text, Button, VSpacing, useBreakpoint } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import numberFormatter from 'bloko/common/numberFormatter';
import { format } from 'bloko/common/trl';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { TopLevelSite } from 'src/models/topLevelSite';
import { UserType } from 'src/models/userType';

const TrlKeys = {
    buy: 'resumesSearch.normalResults.buy',
    applicant: 'resumesSearch.normalResults.applicant.advanced',
    applicantTiny: 'resumesSearch.normalResults.applicant.full.tiny',
    employerTitle: 'resumesSearch.normalResults.employer.title',
    employerDesc: 'resumesSearch.normalResults.employer.desc',
};

const RegistrationAction: TranslatedComponent = ({ trls }) => {
    const isApplicant = useSelector(({ userType }) => UserType.Applicant === userType);
    const isEmployer = useSelector(({ userType }) => UserType.Employer === userType);
    const isAnonimous = useSelector(({ userType }) => UserType.Anonymous === userType);
    const stats = useSelector(({ resumeSearchResult }) => resumeSearchResult?.stats);
    const buyButtonVisible = useSelector((state) => state.topLevelSite !== TopLevelSite.AZ);

    const { isMobile } = useBreakpoint();

    if (!stats?.normalSearchResults) {
        return null;
    }

    const { normalSearchResults, totalUngroupedResults } = stats;
    if (isAnonimous) {
        return null;
    }

    let title;
    let description = '';
    if (isApplicant) {
        if (normalSearchResults < 10) {
            description = trls[TrlKeys.applicantTiny];
        } else {
            description = format(trls[TrlKeys.applicant], {
                '{0}': numberFormatter.format(`${totalUngroupedResults}`),
            });
        }
    } else {
        title = trls[TrlKeys.employerTitle];
        description = format(trls[TrlKeys.employerDesc], {
            '{0}': numberFormatter.format(normalSearchResults.toString()),
        });
    }

    return (
        <>
            <Banner
                stretched
                visible
                showBorder
                showClose={false}
                buttonBase={
                    (isEmployer && buyButtonVisible && (
                        <Button
                            size="small"
                            mode="primary"
                            style="accent"
                            stretched={isMobile}
                            Element={SPALink}
                            to="/price"
                            data-qa="resume-serp__action-after-search"
                        >
                            {trls[TrlKeys.buy]}
                        </Button>
                    )) ||
                    undefined
                }
                title={title ? <Text typography="title-5-semibold">{title}</Text> : undefined}
                content={<Text typography="paragraph-2-regular">{description}</Text>}
            />
            <VSpacing default={16} gteM={32} />
        </>
    );
};

export default translation(RegistrationAction);
